"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
var matchAllVariables = function matchAllVariables(equation) {
  if (!equation) {
    return [];
  }
  var matching = equation.matchAll(/[a-zA-Z0-9_]+/g);
  if (!matching) {
    return [];
  }
  return _toConsumableArray(matching).map(function (match) {
    return match[0];
  }).filter(function (match) {
    return !!match.match(/[a-zA-Z_]+/, 'g');
  });
};
var usageCount = function usageCount(variables, variable) {
  return variables.filter(function (v) {
    return v === variable;
  }).length;
};
var unknownVariables = function unknownVariables(equation, variables) {
  var matchedVariables = _toConsumableArray(new Set(matchAllVariables(equation)));
  return matchedVariables.filter(function (matchedVariable) {
    return !(variables || []).includes(matchedVariable);
  });
};
var missingVariables = function missingVariables(equation, variables) {
  var matchedVariables = _toConsumableArray(new Set(matchAllVariables(equation)));
  return (variables || []).filter(function (variable) {
    return !matchedVariables.includes(variable);
  });
};
var _default = exports["default"] = {
  matchAllVariables: matchAllVariables,
  usageCount: usageCount,
  unknownVariables: unknownVariables,
  missingVariables: missingVariables
};